import { defineMessages } from 'react-intl';

// English strings are placeholders pending design copy.
export const toolCallLabelMessages = defineMessages({
  toolFailed: {
    id: 'BLXpgoYUW5',
    defaultMessage: '{label} failed',
    description: 'Inline tool-call label when a tool or group failed',
  },
  toolCancelled: {
    id: 'ipHmSjmyna',
    defaultMessage: '{label} cancelled',
    description: 'Inline tool-call label when a tool or group was cancelled',
  },
  groupFailedCount: {
    id: 'shyGdqIGB0',
    defaultMessage: '{count} failed',
    description:
      'Grouped tool-call caption counting failed members when some but not all calls failed',
  },
  groupCancelledCount: {
    id: '95zoXOBQ90',
    defaultMessage: '{count} cancelled',
    description:
      'Grouped tool-call caption counting cancelled members when some but not all calls were cancelled',
  },
  toolRunning: {
    id: '1UOg2pRRvr',
    defaultMessage: 'Running tool',
    description: 'Generic in-progress label when the tool is unknown',
  },
  toolRan: {
    id: 'eEnvzFoZLN',
    defaultMessage: 'Ran tool',
    description: 'Generic completed label when the tool is unknown',
  },
  toolGeneric: {
    id: 'phVKN9bn9u',
    defaultMessage: 'Tool',
    description:
      'Generic noun used when wrapping an unknown tool in failed or cancelled copy',
  },
  toolsRunning: {
    id: '22ipDM6nKd',
    defaultMessage: '{count, plural, one {Running # tool} other {Running # tools}}',
    description: 'Generic in-progress label for a group of unknown tools',
  },
  toolsRan: {
    id: 'Pom/l3EkOB',
    defaultMessage: '{count, plural, one {Ran # tool} other {Ran # tools}}',
    description: 'Generic completed label for a group of unknown tools',
  },
  transcribingStarted: {
    defaultMessage: 'Started transcribing',
    id: 'nIcxBCEtln',
    description: 'Work timeline row when the agent started session transcription',
  },
  transcribingResumed: {
    defaultMessage: 'Resumed transcribing',
    id: 'nfz5WgQALs',
    description: 'Work timeline row when the agent resumed session transcription',
  },
  transcribingPaused: {
    defaultMessage: 'Paused transcribing',
    id: '6Cjma3CQxg',
    description: 'Work timeline row when the agent paused session transcription',
  },
  transcribingStopped: {
    defaultMessage: 'Stopped transcribing',
    id: 'Sjdeqh4Csb',
    description: 'Work timeline row when the agent stopped session transcription',
  },
  transcribing: {
    defaultMessage: 'Transcribing',
    id: 'GjWBk2UH6m',
    description:
      'Work timeline row for a session-recording action with no recognised verb',
  },
});
